// removed by extract-text-webpack-plugin
module.exports = {"Label":"_162alY6kzQv8ffqG0W0eIB","SubLabel":"_2fIpkDnWWBQ_-Z1i3BABMo"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Label/style.css
// module id = 655
// module chunks = 0